import { Navigate, useLocation } from "react-router-dom"
import { authService } from "../../services/authService"

interface ProtectedRouteProps {
  children: React.ReactNode
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation()

  if (!authService.isAuthenticated()) {
    return (
      <Navigate
        to="/admin/akm-login"
        state={{ from: location }}
        replace
      />
    )
  }

  return <>{children}</>
}